import script from "./UploadLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadLinks.vue?vue&type=script&setup=true&lang=js"

import "./UploadLinks.vue?vue&type=style&index=0&id=934f79e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-934f79e0"]])

export default __exports__